module.exports = __webpack_public_path__ + "assets/img/0750b13a84ab4a7d5439383b34d580dc.svg";